module.exports = __webpack_public_path__ + "static/img/emotions1_11.85b5ff7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/emotions/images/emotions1_11.png
// module id = 0K6U
// module chunks = 0